import {
    IonButton, IonCard,
    IonCardHeader, IonCardSubtitle, IonCardTitle,
    IonContent, IonIcon,
    IonRefresher,
    IonRefresherContent,
    IonSpinner, useIonAlert, useIonLoading, useIonRouter, useIonViewWillEnter
} from "@ionic/react";
import React, {useEffect, useState} from "react";
import {getUser, setEmail, setIsDisabled, setName} from "../../repositories/adminUserRepository";
import {pencil} from "ionicons/icons";
import {AdminManageUserPermissions} from "../../components/admin/AdminManageUserPermissions";
import {AdminManageUserNames} from "../../components/admin/AdminManageUserNames";

export const AdminViewUser = ({userId}) => {
    const [user, setUser] = useState(null);
    const [userNames, setUserNames] = useState([]);
    const [presentAlert, dismissAlert] = useIonAlert();
    const [presentLoading, dismissLoading] = useIonLoading();
    const [showManageServicesUserNamesTab, setShowManageServicesUserNamesTab] = useState(true);

    const router = useIonRouter();

    const loadUser = async () => {
        await presentLoading({message: 'Loading user...'});
        const userResponse = await getUser(userId);
        setUser(userResponse.user); // TODO: handle 404
        setUserNames(userResponse.userNames);

        await dismissLoading();
    }

    const showIsDisabledButton = () => {
        return <IonButton fill="clear" color={user.disabled ? 'success' : 'danger'}
                          onClick={async () => {
                              await presentLoading({message: (user.disabled ? 'Enabling' : 'Disabling') + ' user...'});
                              const newUser = await setIsDisabled(user.id,!user.disabled)
                              setUser(newUser);
                              await dismissLoading();
                          }}>
            {user.disabled ? 'Enable' : 'Disable'}
        </IonButton>
    }

    const editName = () => {
        presentAlert({
            cssClass: 'custom-alert',
            header: 'Edit name',
            inputs: [
                {
                    name: 'name',
                    type: 'text',
                    placeholder: 'Enter user name',
                    value: user.name
                }
            ],
            buttons: [
                { text: 'Cancel', role: 'cancel', handler: () => dismissAlert() },
                { text: 'Save',
                    handler: async (data) => {
                        await presentLoading({message: 'Setting user name...'});
                        const newUser = await setName(user.id, data.name)
                        setUser(newUser);
                        await dismissLoading();
                    }
                }
            ]
        })
    }

    const editEmail = () => {
        presentAlert({
            cssClass: 'custom-alert',
            header: 'Edit email',
            inputs: [
                {
                    name: 'email',
                    type: 'text',
                    placeholder: 'Enter user email',
                    value: user.email
                }
            ],
            buttons: [
                { text: 'Cancel', role: 'cancel', handler: () => dismissAlert() },
                { text: 'Save',
                    handler: async (data) => {
                        await presentLoading({message: 'Setting user email...'});
                        const newUser = await setEmail(user.id, data.email)
                        setUser(newUser);
                        await dismissLoading();
                    }
                }
            ]
        })
    }

    const reload = async (event) => {
        await loadUser();
        event.detail.complete();
    }

    useIonViewWillEnter(() => {
        loadUser();
    }, [loadUser]);

    if (!user) {
        return <IonContent fullscreen>
            <div className="custom-spinner">
                <IonSpinner></IonSpinner>
            </div>
        </IonContent>
    }

    return <IonContent fullscreen>
        <IonRefresher slot="fixed" onIonRefresh={reload}>
            <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>{ user.name }
                    <IonButton onClick={editName} className="edit-button-icon" fill="clear" shape="round" size="small">
                        <IonIcon slot="icon-only" icon={pencil} />
                    </IonButton>
                </IonCardTitle>
                <IonCardSubtitle>{ user.email }
                    <IonButton onClick={editEmail} className="edit-button-icon" fill="clear" shape="round" size="small">
                        <IonIcon slot="icon-only" icon={pencil} onClick={editEmail} />
                    </IonButton>
                </IonCardSubtitle>
            </IonCardHeader>
            {showIsDisabledButton()}
            {/*<IonButton fill="clear" onClick={() => setShowManageServicesUserNamesTab(true)}>*/}
            {/*    Manage service user names*/}
            {/*</IonButton>*/}
            {/*<IonButton fill="clear" onClick={() => setShowManageServicesUserNamesTab(false)}>*/}
            {/*    Manage permissions*/}
            {/*</IonButton>*/}
        </IonCard>

        { showManageServicesUserNamesTab
            ? <AdminManageUserNames user={user} userNames={userNames} setUserNames={setUserNames} />
            : <AdminManageUserPermissions /> }
    </IonContent>
}